import { Badge } from '@/components/ui/badge';
import type { ProvisioningJobStatus } from '@/services/provisioning';

const LABELS: Record<ProvisioningJobStatus, string> = {
    DISPATCHING: 'Dispatching',
    DISPATCH_FAILED: 'Dispatch failed',
    QUEUED: 'Queued',
    RUNNING: 'Running',
    SUCCEEDED: 'Playbook done',
    VERIFYING: 'Verifying domains',
    VERIFIED: 'Live',
    VERIFY_FAILED: 'Domains never came up',
    FAILED: 'Failed',
    CANCELLED: 'Cancelled',
    TIMED_OUT: 'Timed out',
};

const CLASSES: Record<ProvisioningJobStatus, string> = {
    DISPATCHING: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
    DISPATCH_FAILED: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
    QUEUED: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300',
    RUNNING: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
    SUCCEEDED: 'bg-blue-100 text-blue-700 dark:bg-blue-900/30 dark:text-blue-300',
    VERIFYING: 'bg-amber-100 text-amber-700 dark:bg-amber-900/30 dark:text-amber-300',
    VERIFIED: 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-300',
    VERIFY_FAILED: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
    FAILED: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
    CANCELLED: 'bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400',
    TIMED_OUT: 'bg-red-100 text-red-700 dark:bg-red-900/30 dark:text-red-300',
};

export function ProvisioningStatusBadge({ status }: { status: ProvisioningJobStatus }) {
    return (
        <Badge variant="outline" className={CLASSES[status]}>
            {LABELS[status]}
        </Badge>
    );
}

export const provisioningStatusLabel = (status: ProvisioningJobStatus) => LABELS[status];
